module.exports = __webpack_public_path__ + "img/playbtn.ce6219b2.svg";